import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-780da758"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ws_mb10" }, "待升级设备", -1))
const _hoisted_3 = { class: "dialog-footer" }

import { ref, computed, watch } from 'vue'
import { CODE_ENUM, SUFFIX, PAGE_SIZES } from '@/common'
import {
  queryDeviceFirmwareList,
  queryPendingUpgradeList,
  handleDeviceBatchUpgrade,
} from '@/api'
import { isEmpty } from 'lodash'
import { ElMessage, formatter } from 'element-plus'
import OperationButtonList from '@/components/operation-button-list'


export default /*#__PURE__*/_defineComponent({
  __name: 'batch-update',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: __emit }) {

const props = __props
const $emit = __emit


const formRef =  ref()

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      queryFirmwareList()
      queryDeviceList()
    }
  }
)

const getButtonList = () => {
  return [
    {
      type: 'delete',
      text: '删除',
      onClick: (row: any) => {
        deleteDevice(row)
      },
    },
  ]
}

const deleteDevice = (row: any) => {
  const { deviceId, chipType } = row
  tableData.value = tableData.value.filter((item: any) => {
    return !(item.deviceId === deviceId && item.chipType === chipType)
  })
}

const formInline = ref({
  chipType: '',
  chipVersionId: '',
})

const disabled = computed(() => {
  return !formInline.value.chipType || !formInline.value.chipVersionId
})

const loading = ref(false)

const tableData: any = ref([])
const tableLoading = ref(false)

const tablePageData = computed(() => {
  const { curPage, pageSize } = pageParams.value
  const endIndex = curPage * pageSize
  const startIndex = (curPage - 1) * pageSize

  return tableData.value.slice(startIndex, endIndex)
})

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = computed(() => {
  return tableData.value.length
})

const handleSizeChange = () => {
  pageParams.value.curPage = 1
}
const handleCurrentChange = () => {}

const queryDeviceList = async () => {
  const deviceIds = props.data.map((_: any) => _.deviceId)
  tableLoading.value = true
  const res: any = await queryPendingUpgradeList({
    deviceIds,
  })
  tableLoading.value = false
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res.data || []
  }
}

const chipTypeList: any = ref([])
const firmwareList: any = ref({})

const onChipTypeChange = (chipType: any) => {
  formInline.value.chipVersionId = ''
  tableData.value = tableData.value.map((_) => {
    return {
      ..._,
      chipType,
    }
  })
}

const getFirmwareOps = () => {
  const { chipType } = formInline.value
  return firmwareList.value[chipType] || []
}
const queryFirmwareList = async () => {
  const res: any = await queryDeviceFirmwareList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    const result = (res.data || []).reduce((mo: any, item: any) => {
      const { chipType } = item
      if (mo[chipType]) {
        mo[chipType].push(item)
      } else {
        mo[chipType] = [item]
      }
      return mo
    }, {})
    firmwareList.value = result
    chipTypeList.value = Object.keys(result)
  }
}

const handleSubmit = async () => {
  const { chipType, chipVersionId } = formInline.value
  const deviceUpgradeParams = tableData.value.map(({ deviceId }: any) => {
    return {
      chipType,
      deviceId,
    }
  })
  loading.value = true
  const res: any = await handleDeviceBatchUpgrade({
    firmwareIdOne: chipVersionId,
    deviceUpgradeParams,
  })
  loading.value = false
  if (res?.code === CODE_ENUM.SUCCESS) {
    handleClose()
    $emit('success')
    ElMessage.success('操作成功')
  }
}

const handleClose = () => {
  $emit('update:visible', false)
  formRef.value.resetFields()
}

const col: any = [
  {
    label: '设备名称',
    prop: 'deviceName',
  },
  {
    label: '设备SN',
    prop: 'deviceSn',
  },
  {
    label: '芯片类型',
    prop: 'chipType',
    formatter: ({ chipType }: any) => {
      return chipType || '-'
    },
  },
  {
    label: '当前版本',
    prop: 'version',
    formatter: ({ chipInfo, chipType }: any) => {
      return (
        (chipInfo || []).filter((item: any) => {
          return chipType === item.chipType
        })?.[0]?.version || '-'
      )
    },
  },
]

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    title: "批量升级",
    width: "1100",
    "before-close": handleClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_el_button, {
          disabled: disabled.value,
          loading: loading.value,
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        }, 8, ["disabled", "loading"]),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: handleClose
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 取消 ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        inline: true,
        model: formInline.value,
        "label-position": "left"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "芯片类型",
            prop: "chipType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formInline.value.chipType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.chipType) = $event)),
                placeholder: "请选择",
                clearable: "",
                style: {"width":"280px"},
                onChange: onChipTypeChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chipTypeList.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "版本",
            prop: "chipVersionId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formInline.value.chipVersionId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.chipVersionId) = $event)),
                placeholder: "请选择",
                clearable: "",
                style: {"width":"280px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getFirmwareOps(), (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.firmwareVersion,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tablePageData.value,
          class: "ws_common_table"
        }, {
          empty: _withCtx(() => [
            _createVNode(_component_el_empty, { description: "暂无数据" })
          ]),
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(col, (item, index) => {
              return _createVNode(_component_el_table_column, _mergeProps({ key: index }, {
            ...item,
          }), null, 16)
            }), 64)),
            _createVNode(_component_el_table_column, {
              width: 160,
              label: "操作"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_unref(OperationButtonList), {
                  scope: scope.row,
                  buttonList: getButtonList()
                }, null, 8, ["scope", "buttonList"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, tableLoading.value]
        ]),
        _createVNode(_component_el_pagination, {
          class: "ws_mt50 ws_mb36",
          "current-page": pageParams.value.curPage,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((pageParams.value.curPage) = $event)),
          "page-size": pageParams.value.pageSize,
          "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageParams.value.pageSize) = $event)),
          "page-sizes": _unref(PAGE_SIZES),
          layout: "->, total, sizes, prev, pager, next, jumper ",
          total: total.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})